import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "William Baker", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "cv-heading" }, "Profile", -1)
const _hoisted_3 = { class: "cv-row-half" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Address:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "xxxxxxx, xxxx, xxxx")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Website:")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("wjbaker.com")
const _hoisted_7 = { class: "cv-row-half" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Mobile:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "xxxxx xxxxxx")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "GitHub:")
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("github.com/wjbaker101/")
const _hoisted_11 = { class: "cv-row-half" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "E-Mail:")
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("email@wjbaker.com")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Linkedin:")
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("linkedin.com/in/wjbaker101/")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "cv-heading" }, "Education", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "BSci Computer Science with Placement, Loughborough University"),
  /*#__PURE__*/_createElementVNode("div", null, "2016–2020")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Degree Mark:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "First Class Honours")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Breakdown:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "1st Year (80.8%), 2nd Year (76.2%), 3rd Year (67.9%)")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Relevant Modules:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Final Year Project (72%), Object-Oriented Programming (96%), Mobile App Development (91%), Server-Side Programming (86%), Operating Systems, Networks and The Internet 1 (85%), Advanced Networking (72%)")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Oakwood Park Grammar School"),
  /*#__PURE__*/_createElementVNode("div", null, "2009–2016")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "A Levels:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Maths (A), Computing (B), Physics (D)")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "AS Levels:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Chemistry (C), Further Maths (B),"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Extended Project Qualification (A*) ")
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "GCSEs:")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "3 A*, 5 A, 3 B, (A*s in Mathematics, Computing and Physics)")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", { class: "cv-heading" }, "Work Experience", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Codeweavers - Back End Software Developer"),
  /*#__PURE__*/_createElementVNode("div", null, "September 2020–Present")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Develop and maintain C# APIs."),
  /*#__PURE__*/_createElementVNode("li", null, "AWS integration: IAM, S3."),
  /*#__PURE__*/_createElementVNode("li", null, "Database integration: SQL Server, Postgres, Cassandra."),
  /*#__PURE__*/_createElementVNode("li", null, "Specialist Automotive Finance (SAF) Approved.")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Yell - Undergraduate Software Developer"),
  /*#__PURE__*/_createElementVNode("div", null, "July 2018–August 2019")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Maintained multiple cloud-hosted Java APIs, using frameworks such as Spring Boot."),
  /*#__PURE__*/_createElementVNode("li", null, "Debugged remote-hosted Docker systems."),
  /*#__PURE__*/_createElementVNode("li", null, "Scrum, pair-programming and group project based development."),
  /*#__PURE__*/_createElementVNode("li", null, "Developed using both continuous integration and continuous delivery methodologies."),
  /*#__PURE__*/_createElementVNode("li", null, "Code quality control using SonarQube."),
  /*#__PURE__*/_createElementVNode("li", null, "Used AWS services such as: DynamoDB, Redis, Elastic Beanstalk, Lambda."),
  /*#__PURE__*/_createElementVNode("li", null, "Test-driven development: unit, integration, automation and performance testing.")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Bradleys Foods Ltd. - IT Project Assistant"),
  /*#__PURE__*/_createElementVNode("div", null, "August 2017–Present")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("li", null, "Analysed company’s website in terms of content, speed and SEO.", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Created and maintain ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("cakecraftcentrenorwich.co.uk")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" using classic ASP, showcasing products and services.")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("li", null, "Evaluated and maintained spreadsheets for company’s 3000 products.", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h3", { class: "cv-heading" }, "Achievements", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "The \"Genesis\" Project - Team Project at Yell"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Produced analytical dashboard web application as a team of 4."),
  /*#__PURE__*/_createElementVNode("li", null, "Scheduled and partook in regular meetings with stakeholders."),
  /*#__PURE__*/_createElementVNode("li", null, "Implemented using modern technologies: VueJS frontend and Spring Boot backend."),
  /*#__PURE__*/_createElementVNode("li", null, "Delivered several presentations to showcase project.")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Committee Member of the Loughborough Technology Society - Technical Officer/ Software Officer"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Hosted programming orientated events and workshops, allowing fellow students to participate and learn."),
  /*#__PURE__*/_createElementVNode("li", null, "Mentored attendees on range of topics, including: Docker, Node.js, SASS, JavaScript, HTML/ CSS."),
  /*#__PURE__*/_createElementVNode("li", null, "Worked as a team to create interesting and engaging presentations."),
  /*#__PURE__*/_createElementVNode("li", null, "Created Society’s Website: loughborough.tech, using Jekyll.")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Captain of one of Loughborough’s Counter-Strike: Global Offensive (CS:GO) Teams"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Participated in The NUEL CS:GO Winter Championship 2017."),
  /*#__PURE__*/_createElementVNode("li", null, "Organised members and verified the team was signed up correctly."),
  /*#__PURE__*/_createElementVNode("li", null, "Made sure team members turned up to practice and scheduled matches.")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h3", { class: "cv-heading" }, "Technical Skills", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Programming Languages: C#, Java, Node.js, PHP."),
  /*#__PURE__*/_createElementVNode("li", null, "Front-End Development: HTML5, CSS3, SASS."),
  /*#__PURE__*/_createElementVNode("li", null, "Client-Side Programming: JavaScript, VueJS, AJAX, npm."),
  /*#__PURE__*/_createElementVNode("li", null, "Databases: DynamoDB, MSSQL, MySQL, Redis, Marklogic."),
  /*#__PURE__*/_createElementVNode("li", null, "Web Administration Tools: phpMyAdmin, cPanel, Jenkins, SonarQube, Redmine, Kibana."),
  /*#__PURE__*/_createElementVNode("li", null, "Amazon Web Services: Elastic Beanstalk, Route 53, RDS, Lambda."),
  /*#__PURE__*/_createElementVNode("li", null, "Version Control using Git."),
  /*#__PURE__*/_createElementVNode("li", null, "Containerisation using Docker.")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h3", { class: "cv-heading" }, "Other Skills", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Time Management and Organisation"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Efficiently balanced weekly Technology Society meetings and events whilst also going to Team Project meetings, social events and other society events, keeping a high standard of quality throughout."),
  /*#__PURE__*/_createElementVNode("li", null, "Handled working on many tasks on a daily basis whilst working at Bradleys. For example, gathering content for their website by contacting over 100 companies and managing their responses.")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "cv-row-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Teamwork and Communication"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Voiced opinions and ideas during Technology Society meetings, and made sure presentations and projects were of a high standard, as well as explaining concepts clearly while teaching students topics."),
  /*#__PURE__*/_createElementVNode("li", null, "Expressed ideas and maintained clear communication with fellow team members during the Team Project module in the 2nd year of Computer Science course.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "about-cv-view" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createVNode(_component_LinkComponent, { href: "https://wjbaker.com" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _createVNode(_component_LinkComponent, { href: "https://github.com/wjbaker101/" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("div", null, [
            _createVNode(_component_LinkComponent, { href: "mailto:email@wjbaker.com" }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_14,
          _createElementVNode("div", null, [
            _createVNode(_component_LinkComponent, { href: "https://www.linkedin.com/in/wjbaker101/" }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _hoisted_22,
      _hoisted_23,
      _hoisted_24,
      _hoisted_25,
      _hoisted_26,
      _hoisted_27,
      _hoisted_28,
      _hoisted_29,
      _hoisted_30,
      _createElementVNode("ul", null, [
        _hoisted_31,
        _createElementVNode("li", null, [
          _hoisted_32,
          _createVNode(_component_LinkComponent, { href: "https://cakecraftcentrenorwich.co.uk/" }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _hoisted_34
        ]),
        _hoisted_35
      ]),
      _hoisted_36,
      _hoisted_37,
      _hoisted_38,
      _hoisted_39,
      _hoisted_40,
      _hoisted_41,
      _hoisted_42,
      _hoisted_43,
      _hoisted_44,
      _hoisted_45,
      _hoisted_46,
      _hoisted_47,
      _hoisted_48,
      _hoisted_49
    ]),
    _: 1
  }))
}